export default __webpack_public_path__ + "static/media/040_tunnel.av1.a43f7323.mp4";